import React from "react";

import { AlignedBoxTitle, AlignedBoxSubTitle } from "../../../../styles/texts";
import { GrayButton } from "../../../../styles/buttons";
import GreyCard from "./GreyCard";

interface InfoCardProps {
  logo: React.ReactNode;
  title: string;
  subtitle: string;
  buttonText: string;
  onButtonClick?: () => void;
}

const InfoCard3: React.FC<InfoCardProps> = ({
  logo,
  title,
  subtitle,
  buttonText,
  onButtonClick,
}) => {
  return (
    <GreyCard>
      <div className="flex items-center justify-between w-full gap-4 p-2">
        <div className="flex gap-4">
          {/* Logo */}
          <div className="flex-shrink-0 flex items-center justify-center w-10 h-10">
            {/* Clonar el logo para aplicar estilos */}
            {React.cloneElement(logo as React.ReactElement, {
              style: { width: "100%", height: "100%", objectFit: "contain" },
            })}
          </div>

          {/* Título y Subtítulo usando componentes personalizados */}
          <div className="flex flex-col items-left">
            <AlignedBoxTitle fontSize="20px">{title}</AlignedBoxTitle>
            <AlignedBoxSubTitle fontSize="14px">{subtitle}</AlignedBoxSubTitle>
          </div>
        </div>

        {/* Botón */}
        <div style={{ flexShrink: 0 }}>
          <GrayButton
            label={buttonText}
            onClick={onButtonClick}
            w="full"
            h="40px"
          />
        </div>
      </div>
    </GreyCard>
  );
};

export default InfoCard3;
